import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { GetProcessDetails, GetProcessList, GetCallLogsCountByProcess } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate } from 'react-router-dom';
import { StudentsCountComp } from './dashboard';
import { GetAllInstitutes, GetCallLogsCount, GetInstituteCallLogsCount, GetInstituteCallLogsList, GetStudentsCount } from '../../models/leads';
import { GetUserList } from '../../models/user';


export const StudentsCount = () => {
    const userData = useUserStore;
    const [userList, setUserList] = useState([]);
    const [callCountData, setCallCountData] = useState({});
    const [showLoader1, setshowLoader1] = useState(true);
    const [alertBox, setAlertBox] = useState(false);
    const [userName, setUserName] = useState('');
    const [getCallLogsCount, setGetCallLogsCount] = useState(false);
    const [searchObj, setSearchObj] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState('');
    const [txtSearchStartDate, settxtSearchStartDate] = useState(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' '));
    const [txtSearchEndDate, settxtSearchEndDate] = useState(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' '));
    const [ddlSearchInstitute, setddlSearchInstitute] = useState('All');

    const [getUserList, setGetUserList] = useState(true);
    const [userListData, setUserListData] = useState([]);

    const [callLogsPopup, setCallLogsPopup] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [callLogsSearchObj, setCallLogsSearchObj] = useState({});
    const [callLogs, setCallLogs] = useState([]);

    const [getCallLogsList, setGetCallLogsList] = useState(false);

    const [getInstituteList, setGetInstituteList] = useState(true);
    const [instituteListData, setInstituteListData] = useState([]);

    const navigate = useNavigate();


    const state = {
        userListData: userListData,
        alertBox: alertBox,
        userName: userName,
        loginUserProfile: userData.getState().profile,
        txtSearchStartDate: txtSearchStartDate,
        txtSearchEndDate: txtSearchEndDate,
        callCountData: callCountData,
        getCallLogsCount: getCallLogsCount,
        showLoader1: showLoader1,
        showAlert: showAlert,
        alertMsg: alertMsg,
        ddlSearchInstitute: ddlSearchInstitute,
        callLogsPopup: callLogsPopup,
        selectedUser: selectedUser,
        selectedType: selectedType,
        callLogs: callLogs,
        instituteListData: instituteListData

    }

    useEffect(() => {

        setSearchObj({
            txtSearchStartDate: txtSearchStartDate,
            txtSearchEndDate: txtSearchEndDate,
        })

        setGetCallLogsCount(true)

    }, []);





    const HandleInputs = (e, name) => {
        let value = '';

        if (name == 'txtSearchStartDate' || name == 'txtSearchEndDate') {
            value = e.$d;
        }
        else {
            value = e.target.value;
        }

        if (name == 'txtSearchStartDate') {
            let date = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
            settxtSearchStartDate(date);
        }

        if (name == 'txtSearchEndDate') {
            let date = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
            settxtSearchEndDate(date);
        }

        if (name == 'ddlSearchInstitute') {
            setddlSearchInstitute(value);

            setSearchObj({
                txtSearchStartDate: txtSearchStartDate,
                txtSearchEndDate: txtSearchEndDate,
                ddlSearchInstitute: value
            })
            setGetCallLogsCount(true)
        }

    }

    const HandleCloseAlert = (type) => {
        if (type == 'No') {
            setAlertBox(false);
        }
        else {
        }
    }

    const handleCloseAlert = () => {
        setShowAlert(false);
        setAlertMsg('');
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }


    const CustomSearch = () => {

        if (txtSearchStartDate == '' && txtSearchEndDate != '') {
            // alert('WRONG');
            setShowAlert(true);
            setAlertMsg('Select Correct Date Range');
            return false;
        }

        if (txtSearchStartDate != '' && txtSearchEndDate != '') {
            if (txtSearchEndDate < txtSearchStartDate) {
                setShowAlert(true);
                setAlertMsg('Select Correct Date Range');
                return false;
            }
        }
        setSearchObj({
            txtSearchStartDate: txtSearchStartDate,
            txtSearchEndDate: txtSearchEndDate,
        });

        setshowLoader1(true);
        setGetCallLogsCount(true);

    }

    const Reload = () => {

        let startDate = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ');
        let endDate = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ');

        settxtSearchStartDate(startDate);
        settxtSearchEndDate(endDate);

        setSearchObj({
            txtSearchStartDate: startDate,
            txtSearchEndDate: endDate,
        });

        setddlSearchInstitute('All');

        setshowLoader1(true);
        setGetCallLogsCount(true);

    }


    const HandleCallLogsCountByProcessResponse = (res) => {
        setGetCallLogsCount(false);
        if (res != false && res != 'error') {
            console.log(res.data.studentscountresponse.message.value)
            setCallCountData(res.data.studentscountresponse.message.value);
            setshowLoader1(false);
        }
        else {
            setCallCountData([]);
        }
    }


    const OpenCallLogs = async (userName, type) => {
        setCallLogsSearchObj({
            txtSearchStartDate: txtSearchStartDate,
            txtSearchEndDate: txtSearchEndDate,
            ddlSearchInstitute: userName,
            ddlCallType: type
        })
        setSelectedUser(userName);
        setSelectedType(type);
        setGetCallLogsList(true);
    };

    const HandleCallLogsListByProcessResponse = (res) => {
        setGetCallLogsList(false);
        if (res !== false) {
            setCallLogs(res.data.calllogsresponse.message.value.calllogsresponse.rows)
            if (res.data.calllogsresponse.message.value.calllogsresponse.rows.length > 0) {
                setCallLogsPopup(true);
            }
            else {

            }
        }
        else {
            setCallLogs([])
            setCallLogsPopup(false);
        }
    }

    const CloseCallLogs = async () => {
        setCallLogsPopup(false);
    };

    const HandleGetInstituteListSuccessResponse = (res) => {
        setGetInstituteList(false);
        if (res !== false) {
            setInstituteListData(res.data.leadlistresponse.rows)
        }
        else {
            setInstituteListData([]);
        }
    }

    return (
        <Box>
            <StudentsCountComp mystate={state} HandleInputs={HandleInputs} OpenCallLogs={OpenCallLogs} CloseCallLogs={CloseCallLogs} HandleCloseAlert={HandleCloseAlert} CustomSearch={CustomSearch} Reload={Reload} handleCloseAlert={handleCloseAlert} />
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUsersListSuccessResponse) : "")}
            {getCallLogsCount === true ? GetStudentsCount(pnkstore, searchObj, userData.getState().token, HandleCallLogsCountByProcessResponse) : ''}
            {getCallLogsList === true ? GetInstituteCallLogsList(pnkstore, callLogsSearchObj, userData.getState().token, HandleCallLogsListByProcessResponse) : ''}
            {((getInstituteList === true) ? GetAllInstitutes(pnkstore, {}, userData.getState().token, HandleGetInstituteListSuccessResponse) : "")}
        </Box>
    )
}